export function normalizeChannelName(name: string) {
    return name.replace(/[()]+/g, "").replace(/ /g, "_");
}

export function buildVersioningScheduleSourceId(channel: string) {
    return normalizeChannelName(channel.trim());
}